import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedModule } from '../../../../shared/shared.module';
import { KKM_INFO, KKM_REG_STATUS } from './kkm-info.config';
import { KkmInfo, KkmRegStatusModel } from './kkm-info.types';
import { IKkm, RegStatus } from '../../../../core/modules/retail-places/retail-paces.types';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { IsnaEnabledService } from '../../shared/services/isna-enabled.service';

@UntilDestroy()
@Component({
  selector: 'tax-kkm-info',
  templateUrl: './kkm-info.component.html',
  styleUrls: ['./kkm-info.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    DatePipe,
    SharedModule,
    RouterLink,
  ],
})

export class KkmInfoComponent {
  @Input() kkm?: IKkm & KkmAvailableOperations;
  readonly kkmInfo: KkmInfo[] = KKM_INFO;
  readonly kkmRegStatus: KkmRegStatusModel[] = KKM_REG_STATUS;

  constructor(
    private router: Router,
    private isnaEnabledService: IsnaEnabledService,
  ) {}

  goToPage(item: KkmRegStatusModel, kkmId: number): void {
    if (!item.link) return;
    if ([RegStatus.ErrorReturningOfd, RegStatus.ErrorSwitchingOfd].includes(item.regStatus)) {
      this.isnaEnabledService.checkIsnaEnabled().pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            if (item.link) {
              const queryParams = item.regStatus === RegStatus.ErrorSwitchingOfd ? '?isChangingOfd=true' : '';
              this.router.navigateByUrl(`${item.link}${kkmId}${queryParams}`);
            }
          },
        });
    } else this.router.navigateByUrl(`${item.link}${kkmId}`);
  }
}
